// extracted by mini-css-extract-plugin
export var cardHeader = "_td-0";
export var reorderHandle = "_td-3";
export var titleArea = "_td-1";
export var titleAreaWithHandle = "_td-2";